import script from "./AlertComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AlertComponent.vue?vue&type=style&index=0&id=0614b06e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0614b06e"]])

export default __exports__